import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ProjectEditorPage from './pages/ProjectEditorPage';
import MapViewPage from './pages/MapViewPage';
import ValidatorPage from './pages/ValidatorPage';
import StatsPage from './pages/StatsPage';
import HistoryPage from './pages/HistoryPage';
import AIAssistantPage from './pages/AIAssistantPage';
import AdminUsersPage from './pages/AdminUsersPage';
import ActivityLogPage from './pages/ActivityLogPage';
import VisualizerPage from './pages/VisualizerPage';
import SystemLogsPage from './pages/SystemLogsPage';
import GtfsRtPage from './pages/GtfsRtPage';
import Layout from './components/Layout';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-lg text-slate-600">Cargando...</div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<PrivateRoute><Layout><DashboardPage /></Layout></PrivateRoute>} />
      <Route path="/ai-assistant" element={<PrivateRoute><AIAssistantPage /></PrivateRoute>} />
      <Route path="/projects/:projectId/editor" element={<PrivateRoute><Layout><ProjectEditorPage /></Layout></PrivateRoute>} />
      <Route path="/projects/:projectId/map" element={<PrivateRoute><Layout><MapViewPage /></Layout></PrivateRoute>} />
      <Route path="/projects/:projectId/validator" element={<PrivateRoute><Layout><ValidatorPage /></Layout></PrivateRoute>} />
      <Route path="/projects/:projectId/stats" element={<PrivateRoute><Layout><StatsPage /></Layout></PrivateRoute>} />
      <Route path="/projects/:projectId/history" element={<PrivateRoute><Layout><HistoryPage /></Layout></PrivateRoute>} />
      <Route path="/projects/:projectId/visualizer" element={<PrivateRoute><VisualizerPage /></PrivateRoute>} />
      <Route path="/projects/:projectId/gtfs-rt" element={<PrivateRoute><Layout><GtfsRtPage /></Layout></PrivateRoute>} />
      <Route path="/admin/users" element={<PrivateRoute><Layout><AdminUsersPage /></Layout></PrivateRoute>} />
      <Route path="/admin/activity" element={<PrivateRoute><Layout><ActivityLogPage /></Layout></PrivateRoute>} />
      <Route path="/admin/logs" element={<PrivateRoute><Layout><SystemLogsPage /></Layout></PrivateRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
